import type { EMemoryType, INoteAttachment } from '@/service/note';
import type { ISmartTopicBasic } from '@/service/smart-topic';

import type { CommonResponse } from './responseModel';

export interface CanvasDetailResponse extends CommonResponse<CanvasResponseDetail | undefined> {}

export interface CanvasResponseDetail {
  preId?: string; // deprecated
  nextId?: string; //deprecated
  canvas: CanvasDetail;
  toast?: string;
  supportIframe?: boolean;
}
export interface IParameter {
  topic: string;
  related: string;
  chatAbout: string;
  chosenBiog: string;
}

export interface DocumentContentInfo {
  id: number;
  title?: string;
  error?: string;
  content?: string;
  status?: 'success' | 'uploading' | 'done' | 'error';
  extra?: string; /// 用于存储额外信息
}

export interface CanvasShareResponseDetail extends CanvasResponseDetail {
  userAvatar?: string;
  userName?: string;
}

export enum CanvasUrlType {
  HTML = 'text/html',
  PDF = 'application/pdf',
  MARKDOWN = 'text/markdown',
  MARKDOWN_X = 'text/x-markdown',

  // 图片
  PNG = 'image/png',
  JPEG = 'image/jpeg',
  JPG = 'image/jpg',
  GIF = 'image/gif',
  // text
  TXT = 'text/plain',
  // word
  MS_WORD = 'application/msword',
  VND_DOCUMENT = 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',

  // voice
  WAV = 'audio/wav'
}

export enum CanvasDataInfoDetailType {
  NOTE = 'NOTE',
  QUICKNOTE = 'QUICKNOTE',
  KNOWLEDGE = 'KNOWLEDGE'
}

export const isMarkdown = (type?: CanvasUrlType): boolean => {
  return type === CanvasUrlType.MARKDOWN || type === CanvasUrlType.MARKDOWN_X;
};

export const isHTML = (type?: CanvasUrlType): boolean => {
  return type === CanvasUrlType.HTML;
};

export const isDocument = (type?: CanvasUrlType): boolean => {
  return type !== CanvasUrlType.HTML && type !== CanvasUrlType.PDF;
};

export interface DataInfoDetail {
  attachment?: INoteAttachment[];
  content?: string;
  originUrl?: string;
  hints?: string;
  process: DatahubDetailStatus;
  title?: string;
  sourceType?: CanvasDataInfoDetailType | string;
  createTimestamp?: string;
  summary?: string;
  insight?: string;
  memoryType?: EMemoryType;
}

export interface CanvasAdd {
  mindId: string;
  url?: string;
  noteId?: string;
  sessionId?: string;
  source?: ZoomInSource;
  mode?: EEditMode;
  id?: string;
  analyzeText?: string[];
}

export interface CanvasDetail {
  id: string;
  mindId: number;
  userId: number;
  dataHubId: string;
  failReason?: string;
  originUrl: string;
  dataParseType: CanvasUrlType;
  dataInfo: DataInfoDetail;
  blockList: BlockDetail[];
  createTimestamp?: string;
  needRelearn?: boolean;
  smartTopics: ISmartTopicBasic[];
}

export enum DatahubDetailStatus {
  UNDONE = 'undone',
  DOING = 'doing',
  REDO = 'redo',
  DONE = 'done'
}
export interface DatahubDetail {
  docId: number;
  content: string;
  source: string;
  title: string;
  summary: string;
  keywords: string[];
  process: DatahubDetailStatus;
}

export enum AppendType {
  CONTINUE = 'CONTINUE',
  GENERATE_BELOW = 'GENERATE'
}
export interface AppendGenerateRequestData {
  blockId: string | number;

  type: AppendType;
  content: string;
}

export interface ReplaceGenerateRequestData {
  blockId: string | number;

  content: string;
}

export interface BlockModel {
  content: string;
  type: string;
}

export enum ToolsItemType {
  replace = 'replace',
  continue = 'continue',
  generate = 'generate'
}

export interface BlockDetail {
  blockContent: string;
  blockStatus: string;
  blockType: string;
  createTime: string;
  docId: number;
  id: number | string;
  learnStatus: string;
  nextBlockId: number | string;
  prevBlockId: number | string;
  updateTime: string;
  toolList: ToolsItemType[];
}

export interface ReplaceSectionContentRequestData {
  blocks: BlockModel[];
  originId: string | number;
}

export interface AppendSectionContentRequestData {
  blocks: BlockModel[];
  nextId?: string | number;

  preId?: string | number;
}

export enum CanvasRecentType {
  pdf = 'pdf',
  word = 'word',
  link = 'link',
  image = 'image',
  text = 'text',
  newsletter = 'newsletter',
  shopify = 'shopify'
}

export interface CanvasRecentItem {
  id: string;
  originUrl: string;
  canvasId: number;
  lastZoomInTime: string;
  contentType: CanvasRecentType;
  title: string;
  type: string;
  imageList: string[];
  url: string;
  icon: string;
  description: string;
  siteName: string;
}

export enum ZoomInSource {
  newsletter = 'newsletter', // 从pins中newsletter类型的卡片zoom in
  email = 'email', // 从pins中email automation类型的卡片zoom in
  calendar = 'calendar', // 从pins中calendar automation类型的卡片zoom in
  web = 'web', // 从pins中web automation类型的卡片zoom in
  chat = 'chat', // 从chat链路里任何地方出发zoom in， 需要在接口里添加当前sessionId
  other = 'other' // 从其他的地方zoom in
}

export interface ZoomInDetail {
  url?: string;
  noteId?: string;
  source: ZoomInSource;
}

export enum EEditMode {
  EDIT = 'edit',
  VIEW = 'view'
}

export interface EditNoteCanvasData {
  id: string;
  title: string;
  content: string;
  attachments: INoteAttachment[];
  mindId: string;
  audioLanguage?: string;
}
export interface EditShotAudioCanvasData {
  content: string;
  docId: number;
}
